const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');
const OperatingSystemIcons = require('./operating_system_icons.js');

class DropdownVariant extends React.Component {
  onClick() {
    this.props.onChooseVariant(this.props.variant);
  }

  downloadSize() {
    if (this.props.variant.fileSize) {
      return <span className="pull-right">{this.props.variant.fileSize}</span>;
    }

    return false;
  }

  render() {
    return (
      <div
        className="dropdown-option mini-module bordered bd-rounded"
        onClick={() => this.onClick()}
      >
        <div className="small strong">
          <i
            className={
              classNames(
                'fa',
                'mr-half',
                `fa-${OperatingSystemIcons[this.props.variant.operatingSystem.value_uuid]}`
              )
            }
          />
          {this.props.variant.operatingSystem.value_name}
        </div>
        <div className="fine-print">
          {this.props.variant.fileTypeNames.join(I18n.t('js.listSeparator'))}
          {this.downloadSize()}
        </div>
      </div>
    );
  }
}

DropdownVariant.propTypes = {
  variant: PropTypes.object.isRequired,
  onChooseVariant: PropTypes.func.isRequired,
};

module.exports = DropdownVariant;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/dropdown_variant.jsx